var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 10.708c0-.633-.057-1.242-.162-1.826h-8.41v3.453h4.806a4.107 4.107 0 0 1-1.782 2.695v2.24h2.886c1.688-1.554 2.662-3.843 2.662-6.562Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.178 19.433c2.411 0 4.432-.8 5.91-2.163l-2.886-2.24c-.8.536-1.822.852-3.024.852-2.325 0-4.293-1.57-4.995-3.68H2.2v2.312a8.925 8.925 0 0 0 7.978 4.92Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.183 12.201a5.368 5.368 0 0 1-.28-1.696c0-.589.101-1.16.28-1.697V6.495H2.2a8.925 8.925 0 0 0-.95 4.01c0 1.44.345 2.804.95 4.01L5.183 12.2Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.178 5.127c1.311 0 2.488.451 3.413 1.336l2.561-2.561c-1.546-1.44-3.567-2.326-5.974-2.326-3.49 0-6.51 2.001-7.978 4.92l2.983 2.312c.702-2.11 2.67-3.68 4.995-3.68Z",
    fill: "#EA4335"
  })));
};
export default SvgGoogle;